/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { company } from '../models/company';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompaniesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count companies
   * Count companies (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of company documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompaniesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companies/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one company
   * Find one company by its unique identifier.
   * @param identifier company unique identifier
   * @param fromLang Locale-style string indicating from which language the backend should translate relevant string values - works in conjunction with toLang
   * @param toLang Locale-style string indicating the backend should translate relevant string values to the specified language - works in conjunction with fromLang
   * @returns any One company document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompanies(
    identifier: string,
    fromLang?: string,
    toLang?: string,
  ): CancelablePromise<{
    data?: company;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companies/{identifier}',
      path: {
        'identifier': identifier,
      },
      query: {
        'fromLang': fromLang,
        'toLang': toLang,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one company which exists or not
   * Replace one company which exists or not
   * @param identifier company unique identifier
   * @param requestBody
   * @returns any company replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCompanies(
    identifier: string,
    requestBody?: company,
  ): CancelablePromise<{
    data?: company;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/companies/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing company
   * Partially update one existing company
   * @param identifier company unique identifier
   * @param requestBody
   * @returns any updated company. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCompanies(
    identifier: string,
    requestBody?: company,
  ): CancelablePromise<{
    data?: company;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/companies/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many companies
   * Find many companies (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @param fromLang Locale-style string indicating the backend should translate relevant string values to the specified language
   * @param toLang Locale-style string indicating the backend should translate relevant string values to the specified language
   * @returns any One or many company documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCompanies1(
    filter?: parametersFilter,
    fromLang?: string,
    toLang?: string,
  ): CancelablePromise<{
    data?: Array<company>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/companies',
      query: {
        'filter': filter,
        'fromLang': fromLang,
        'toLang': toLang,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many companies which exists or not
   * Replace many companies which exists or not
   * @param requestBody
   * @returns any companies replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCompanies1(
    requestBody?: Array<company>,
  ): CancelablePromise<{
    data?: Array<company>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/companies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing company
   * Partially update many existing company
   * @param requestBody
   * @returns any companies updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCompanies1(
    requestBody?: Array<company>,
  ): CancelablePromise<{
    data?: Array<company>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/companies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

}
